export default [
  {
    path: '/admin/reports/yearly-expense-items',
    name: 'yearly-expense-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/expense/yearly-expense-item')
  },
  {
    path: '/admin/reports/monthly-expense-items',
    name: 'monthly-expense-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/expense/monthly-expense-item')
  },
  {
    path: '/admin/reports/expense/daily-expenses',
    name: 'daily-expense',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/expense/daily-expense')
  },
  {
    path: '/admin/reports/expense/daily-cash-advances',
    name: 'daily-cash-advance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/expense/daily-cash-advance')
  }
]
